module.exports = __webpack_public_path__ + "0bacafc4dd2fd09a04adf6a108409387.svg";